(() => {
  const mounts = document.querySelectorAll('[data-planned-build-save]');
  if (!mounts.length) return;

  mounts.forEach((mount) => {
    if (mount.dataset.plannedBuildReady === 'true') return;
    mount.dataset.plannedBuildReady = 'true';
    const openButton = mount.querySelector('[data-planned-build-open]');
    const dialog = mount.querySelector('[data-planned-build-dialog]');
    const formNode = mount.querySelector('[data-planned-build-form]');
    if (!openButton || !dialog || !formNode) return;
    const formId = String(mount.dataset.formId || '');
    const productForm = formId ? document.getElementById(formId) : null;
    const variantControl = productForm?.querySelector('[name="id"]');
    const vehicle = formNode.querySelector('[data-planned-build-vehicle]');
    const build = formNode.querySelector('[data-planned-build-build]');
    const newBuild = formNode.querySelector('[data-planned-build-new-build]');
    const fields = formNode.querySelector('[data-planned-build-fields]');
    const signin = formNode.querySelector('[data-planned-build-signin]');
    const signinLink = formNode.querySelector('[data-planned-build-signin-link]');
    const status = formNode.querySelector('[data-planned-build-status]');
    const error = formNode.querySelector('[data-planned-build-error]');
    const actions = formNode.querySelector('[data-planned-build-actions]');
    const targetDate = formNode.querySelector('[data-planned-build-target-date]');
    let context = null;
    let busy = false;

    const currentVariantId = () => String(variantControl?.value || mount.dataset.variantId || '');
    const configurationState = () => window.AvidProductConfigurationState?.[formId] || null;
    const setError = (message = '') => {
      error.hidden = !message;
      error.textContent = message;
    };
    const setBusy = (next, message = '') => {
      busy = next;
      formNode.querySelectorAll('[data-planned-build-submit]').forEach((button) => { button.disabled = next; });
      if (message) {
        status.hidden = false;
        status.textContent = message;
      }
    };
    const isoToday = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);

    const loginDestination = () => {
      const returnUrl = new URL(window.location.href);
      returnUrl.searchParams.set('planned_build', 'open');
      const login = new URL(String(mount.dataset.loginUrl || '/account/login'), window.location.origin);
      login.searchParams.set('return_url', `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`);
      return `${login.pathname}${login.search}`;
    };

    const populate = (payload) => {
      context = payload;
      vehicle.replaceChildren(new Option('Choose a Garage vehicle', ''));
      (payload.vehicles || []).forEach((item) => vehicle.add(new Option(item.label, item.id)));
      build.replaceChildren(new Option('Choose a Planned Build', ''));
      (payload.builds || []).forEach((item) => {
        const vehicleLabel = (payload.vehicles || []).find((candidate) => candidate.id === item.vehicleId)?.label;
        build.add(new Option(vehicleLabel ? `${item.title} · ${vehicleLabel}` : item.title, item.id));
      });
      build.add(new Option('Create a new named build', 'new'));
      const selectedVehicleId = payload.matchedVehicleId || '';
      if (selectedVehicleId) vehicle.value = selectedVehicleId;
      if (payload.matchingItem?.vehicleId) vehicle.value = payload.matchingItem.vehicleId;
      if (payload.matchingItem?.buildId) build.value = payload.matchingItem.buildId;
      if (!(payload.builds || []).some((item) => !selectedVehicleId || item.vehicleId === selectedVehicleId)) build.value = 'new';
      if (payload.matchingItem) {
        formNode.elements.quantity.value = payload.matchingItem.quantity || 1;
        formNode.elements.priority.value = payload.matchingItem.priority || 'normal';
        formNode.elements.targetDate.value = payload.matchingItem.targetDate || '';
        formNode.elements.notes.value = payload.matchingItem.notes || '';
        targetDate.required = Boolean(payload.matchingItem.targetDate);
      }
      syncBuildChoices();
      fields.hidden = false;
      actions.hidden = false;
      status.hidden = true;
    };

    const syncBuildChoices = () => {
      const chosenVehicle = vehicle.value;
      [...build.options].forEach((option) => {
        if (!option.value || option.value === 'new') return;
        const candidate = (context?.builds || []).find((item) => item.id === option.value);
        option.hidden = Boolean(chosenVehicle && candidate?.vehicleId !== chosenVehicle);
        option.disabled = option.hidden;
      });
      if (build.selectedOptions[0]?.disabled) build.value = '';
      newBuild.hidden = build.value !== 'new';
      formNode.elements.buildTitle.required = build.value === 'new';
    };

    const load = async () => {
      setError('');
      fields.hidden = true;
      signin.hidden = true;
      actions.hidden = true;
      targetDate.min = isoToday();
      setBusy(true, 'Loading your Garage…');
      try {
        const url = new URL(String(mount.dataset.proxyUrl || '/apps/avid-commerce/planned-builds'), window.location.origin);
        url.searchParams.set('product_id', String(mount.dataset.productId || ''));
        url.searchParams.set('variant_id', currentVariantId());
        try {
          const storefrontVehicle = sessionStorage.getItem('avid:vehicle-context');
          if (storefrontVehicle) url.searchParams.set('vehicle_context', storefrontVehicle);
        } catch (_error) { /* Session storage may be restricted. */ }
        const state = configurationState();
        if (state?.configurationFingerprint) url.searchParams.set('configuration_fingerprint', state.configurationFingerprint);
        const response = await fetch(`${url.pathname}${url.search}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const payload = await response.json().catch(() => ({}));
        if (response.status === 401 || payload.authenticationRequired) {
          signinLink.href = loginDestination();
          signin.hidden = false;
          status.hidden = true;
          return;
        }
        if (!response.ok) throw new Error(payload.error || 'My AVID Garage could not be loaded.');
        populate(payload);
      } catch (caught) {
        status.hidden = true;
        setError(caught instanceof Error ? caught.message : 'My AVID Garage could not be loaded.');
      } finally {
        setBusy(false);
      }
    };

    const submit = async (event) => {
      event.preventDefault();
      if (busy) return;
      const submitter = event.submitter;
      const data = new FormData(formNode);
      setError('');
      if (!data.get('targetDate') && !context?.matchingItem?.id) return setError('Choose a target date for this Planned Build item.');
      const state = configurationState();
      if (state && state.valid !== true) return setError('Complete every required product choice before saving this configured system.');
      setBusy(true, 'Saving this product to your Planned Build…');
      try {
        const response = await fetch(String(mount.dataset.proxyUrl || '/apps/avid-commerce/planned-builds'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            shopifyProductId: String(mount.dataset.productId || ''),
            shopifyVariantId: currentVariantId(),
            vehicleId: data.get('vehicleId'),
            buildId: data.get('buildId') === 'new' ? null : data.get('buildId'),
            buildTitle: data.get('buildId') === 'new' ? data.get('buildTitle') : null,
            quantity: data.get('quantity'),
            priority: data.get('priority'),
            targetDate: data.get('targetDate'),
            notes: data.get('notes'),
            configuration: state ? {
              productConfigurationVersionId: state.productConfigurationVersionId,
              configurationFingerprint: state.configurationFingerprint,
              selections: state.selections || []
            } : null,
            idempotencyKey: `planned-build-${crypto.randomUUID()}`
          })
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || 'The product could not be saved.');
        if (submitter?.value === 'jump' && payload.plannedBuildUrl) {
          window.location.assign(payload.plannedBuildUrl);
          return;
        }
        dialog.close();
        document.dispatchEvent(new CustomEvent('avid:toast', { detail: { message: payload.message || 'Saved to Planned Build.' } }));
        openButton.textContent = 'Saved to Planned Build';
      } catch (caught) {
        status.hidden = true;
        setError(caught instanceof Error ? caught.message : 'The product could not be saved.');
      } finally {
        setBusy(false);
      }
    };

    openButton.addEventListener('click', () => { dialog.showModal(); void load(); });
    formNode.addEventListener('submit', submit);
    formNode.querySelector('[data-planned-build-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    vehicle.addEventListener('change', syncBuildChoices);
    build.addEventListener('change', syncBuildChoices);
    variantControl?.addEventListener('change', () => { context = null; });
    if (new URL(window.location.href).searchParams.get('planned_build') === 'open') {
      window.setTimeout(() => openButton.click(), 0);
    }
  });
})();
